import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Password"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.75 1.50009C12.0221 1.50009 9 4.52217 9 8.25009C8.99935 8.91353 9.09794 9.57333 9.2925 10.2076L1.5 18.0001V22.5001H6L13.7925 14.7076C15.7469 15.3073 17.8677 14.9889 19.5599 13.8418C21.2521 12.6948 22.3333 10.8426 22.5 8.80509C22.6514 7.20425 22.2112 5.6034 21.2625 4.30509C19.9867 2.53371 17.933 1.48869 15.75 1.50009ZM18 10.4999C18.8284 10.4999 19.5 9.82831 19.5 8.99988C19.5 8.17145 18.8284 7.49988 18 7.49988C17.1716 7.49988 16.5 8.17145 16.5 8.99988C16.5 9.82831 17.1716 10.4999 18 10.4999ZM14.25 13.2751C14.7365 13.4223 15.2417 13.4981 15.75 13.5001C17.5459 13.5015 19.2179 12.5849 20.1825 11.0701C20.7658 10.1819 21.052 9.13143 21 8.07009C20.9474 6.26162 19.9673 4.60766 18.4063 3.69301C16.8453 2.77835 14.9234 2.73191 13.32 3.57009C11.0615 4.79511 9.99135 7.45157 10.77 9.90009L10.9875 10.6126L10.35 11.2501L3 18.6226V21.0001H5.3775L7.035 19.3426L6 18.3076L7.0575 17.2501L8.0925 18.2851L9.285 17.0926L8.25 16.0576L9.3075 15.0001L10.365 16.0351L12.75 13.6501L13.3875 13.0126L14.25 13.2751Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Password.vue"]]);
